import {
    useContext,
    type FC
} from "react";
import {
    View
} from "react-native";
import type ICardContentProps from "./type";
import stylesheet, {
    CARD_CONTENT_SKELETON_LINES,
    CARD_MEDIA_ASPECT_RATIO,
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    CardPartContentProps
} from "../../type";
import {
    CardContentFlushContext,
    CardLayoutContext,
    withCardContext
} from "../../context";
import Skeleton from "../../../skeleton";

const CardContentContent: FC<CardPartContentProps<ICardContentProps>> = ({
    customTheme: customThemeProp,
    isFlush = false,
    placeholder,
    children,
    context,
    style,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        shapeConfigs,
        radiuses,
        borders,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const layout = useContext(CardLayoutContext);

    const {
        placeholder: placeholderDynamicStyle,
        container: containerDynamicStyle
    } = useStyles({
        inset: context.inset,
        shapeConfigs,
        radiuses,
        borders,
        isFlush,
        layout,
        spaces
    });

    const isEdge = isFlush && (layout.isFirst || layout.isLast);

    const renderPlaceholder = () => {
        if(placeholder) {
            return placeholder;
        }

        if(isEdge) {
            return <Skeleton
                aspectRatio={CARD_MEDIA_ASPECT_RATIO}
                customTheme={customTheme}
                radius="none"
            />;
        }

        return <Skeleton
            lines={CARD_CONTENT_SKELETON_LINES}
            style={placeholderDynamicStyle}
            typography="bodyMediumSize"
            customTheme={customTheme}
            variant="text"
            width="auto"
        />;
    };

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            isEdge ? stylesheet.edge : undefined,
            context.isPressable ? stylesheet.inert : undefined,
            containerDynamicStyle
        ]}
    >
        <CardContentFlushContext.Provider
            value={isFlush}
        >
            {context.isLoading ? renderPlaceholder() : children}
        </CardContentFlushContext.Provider>
    </View>;
};
export default withCardContext("content", CardContentContent);
